import { Flex, Text } from '@mantine/core';
import { IconChevronDown, IconStar, IconStarFilled } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type VersionTileProps = {
  version: string;
  date: string;
  variant: 'primary' | 'past';
};

export default function VersionTile({ version, date, variant }: VersionTileProps) {
  const isPrimary = variant === 'primary';

  return (
    <Flex
      align="center"
      gap="xxs"
      h={28}
      px="xs"
      bg={isPrimary ? 'brand.1' : undefined}
      style={{
        borderRadius: 'var(--mantine-radius-xl)',
        border: isPrimary ? undefined : '1px solid var(--mantine-color-brand-4)',
      }}
    >
      {isPrimary ? (
        <IconStarFilled size={16} color="var(--mantine-color-warning-6)" />
      ) : (
        <IconStar size={16} color="var(--mantine-color-gray-4)" />
      )}
      <Text size="sm" c="black">
        <Text span fw={FONT_WEIGHTS.bold}>
          {version}
        </Text>
        : {date}
      </Text>
      <IconChevronDown size={16} color="black" />
    </Flex>
  );
}
